import { render, staticRenderFns } from "./MediasEProjecao.vue?vue&type=template&id=2371bd00&scoped=true"
import script from "./MediasEProjecao.vue?vue&type=script&lang=js"
export * from "./MediasEProjecao.vue?vue&type=script&lang=js"
import style0 from "./MediasEProjecao.vue?vue&type=style&index=0&id=2371bd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371bd00",
  null
  
)

export default component.exports